<app-landing-toolbar></app-landing-toolbar>
<div class="landing-top-card primary-background">
    <div class="landing-content">
        <h1 class="site-title">DeckPlan Features</h1>
        <h3>We're adding new features all the time!</h3>
        <p class="blurb-line">
            We're making DeckPlan the best tool for managing your Magic: The Gathering collection online. Whether that means
            tracking the value of your cards, planning out decks for your next major tournament or casual game with friends,
            or just want to keep up with the hobby, we're trying to make that easier.
        </p>
    </div>
</div>
<div class="landing-content column-flex">
    <div class="row-flex">
        <div class="feature-side">
            <h2>Deck Planning and Construction</h2>
            <p>
                Use our rules-assisted deck planner to build your preferred decks! It supports the major
                formats, including Commander, Brawl, Standard, Modern, Legacy, Vintage, Pauper, and others.
            </p>
            <p>
                Find all of the planning statistics that you're used to, including CMC charts, color wheel, and
                card type statistics.
            </p>
            <p>
                Share your deck plans privately with your friends or publicly with the community-- you can share
                by providing a link to a limited set of people or mark them as public to see what the community
                thinks of your epic planning. Mark decks you like and see which decks are most popular across DeckPlan!
            </p>
        </div>
        <div class="feature-side">
            <img alt="Deck Planning Screenshot" src="assets/featureScreens/deckPlanner.png">
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side">
            <img alt="Advanced Search Screenshot" src="assets/featureScreens/advancedSearch.png">
        </div>
        <div class="feature-side">
            <h2>Advanced Search Tools</h2>
            <p>
                Use our advanced query construction tool to quickly find the cards you're looking for. Search for
                values on any part of the card!
            </p>
            <p>
                Additionally, get a look at popular cards across the community and hobby news right on your home page
                when you log in!
            </p>
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side">
            <h2>Manage Your Collection</h2>
            <p>
                Build and manage your collection, tracking quantities and exact card types, including card condition and
                foils. <span class="pending-feature">Track the valuation of your collection as it grows so you can better
                manage your investment! <sup>Upcoming Feature</sup></span>
            </p>
            <p>
                <span class="pending-feature">Import and Export your cards using standard list formats-- why do all of the work to manually enter your
                collection on one tool only to have to manually enter it on another? We've got your back!
                <sup>Upcoming Feature</sup></span>
            </p>
            <p>
                <span class="pending-feature">And just like with your deck plans, share your whole collection or just a part privately with your friends
                or publicly with the wider community, making it easier to plan for trades, or just to show off!
                <sup>Upcoming Feature</sup></span>
            </p>
        </div>
        <div class="feature-side">
            <img alt="Inventory Screenshot" src="assets/featureScreens/inventory.png">
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side">
            <img alt="Coming Soon" src="assets/featureScreens/comingSoon.png">
        </div>
        <div class="feature-side column-flex">
            <div>
                <h2 class="pending-feature">Add cards with just a quick snapshot <sup>Upcoming Feature</sup></h2>
                <p class="pending-feature">
                    Manually entering all of your cards with a keyboard is a lot of work. Why not take a quick snapshot
                    with your phone and have DeckPlan do it for you? We'll do all of the hard work of recognizing what
                    you have in the picture and tell you what we found so you can put it into your collection or add it
                    to your deck plans!
                </p>
            </div>
            <div class="pending-feature planner-feature-flex">
                Available to Planner-level members
            </div>
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side column-flex">
            <div>
                <h2 class="pending-feature">Get Intelligent Deck Planning Assistance <sup>Upcoming Feature</sup></h2>
                <p class="pending-feature">
                    Ever wondered where the current meta is going? What are all of the popular tournament decks right now?
                    What really goes well with this combo you're trying to build? Our intelligent Deck Planning Assistant
                    will help you with that! It analyzes the current state of the hobby and provides you with hints and
                    ideas to help make your deck smash the competition!
                </p>
            </div>
            <div class="pending-feature planner-feature-flex">
                Available to Planner-level members
            </div>
        </div>
        <div class="feature-side">
            <img alt="Coming Soon" src="assets/featureScreens/comingSoon.png">
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side">
            <img alt="Coming Soon" src="assets/featureScreens/comingSoon.png">
        </div>
        <div class="feature-side column-flex">
            <div>
                <h2 class="pending-feature">Print out your deck list ready for tournaments <sup>Upcoming Feature</sup></h2>
                <p class="pending-feature">
                    DeckPlan is prepared to help you get ready for tournaments more easily! You've gone to all of the
                    trouble to plan your deck out, why should you have to manually type or hand-write your painstakingly
                    created deck plan? No worries, we'll fill out the form for you, and hand it over ready for printing.
                    No more hassle!
                </p>
            </div>
            <div class="pending-feature planner-feature-flex">
                Available to Planner-level members
            </div>
        </div>
    </div>
    <div class="row-flex">
        <div class="feature-side column-flex">
            <div>
                <h2 class="pending-feature">Use your phone to manage your Plans <sup>Upcoming Feature</sup></h2>
                <p class="pending-feature">
                    It's not always convenient to go sit down at a computer to manager your deck plans or your collection.
                    Our smart phone app will let you do it on the go! Access your DeckPlan data from your mobile device to
                    plan decks, manage your collection, and even take pictures of your cards to be added to your collection.
                </p>
            </div>
            <div class="pending-feature planner-feature-flex">
                Phone app available to all members, but photo card recognition available only to Planner-level members
            </div>
        </div>
        <div class="feature-side">
            <img alt="Coming Soon" src="assets/featureScreens/comingSoon.png">
        </div>
    </div>
</div>
